<template>
  <FilterLayout v-model="advance_filter">
    <AddressSection
      :province="filterState.address.province"
      :amphur="filterState.address.amphur"
      :tumbol="filterState.address.tumbol"
      :village="filterState.address.village"
      @update:province="updateAddress($event, 'province')"
      @update:amphur="updateAddress($event, 'amphur')"
      @update:tumbol="updateAddress($event, 'tumbol')"
      @update:village="updateAddress($event, 'village')"
      parentComponent="household"
      key="household"
      :disabledProvince="getAllowActionByCurrRole('disabled-province-search')"
    />
    <HouseholdCharacteristicsSection v-model="filterState.household_type" />

    <!-- advance -->
    <section data-test="filter-advance" v-show="advance_filter">
      <hr class="border-theme-33 mt-3" />
      <ProblemSection class="mt-3" v-model="filterState.problems" />
      <HouseStableSection class="mt-3" v-model="filterState.house_solidity" />
      <AccommodationSection class="mt-3" v-model="filterState.house_type" />

      <section data-test="filter-number-family-scetion">
        <h4 class="text-base font-normal leading-none text-theme-33">
          จำนวนครอบครัว
        </h4>
        <div class="flex flex-nowrap justify-center items-center p-2">
          <input
            type="number"
            class="form-control form-control-sm text-center"
            placeholder="เริ่มต้น"
            v-model="filterState.family_range.start"
          />
          <p class="inline-block mx-2">
            -
          </p>
          <input
            type="number"
            class="form-control form-control-sm text-center"
            placeholder="สิ้นสุด"
            v-model="filterState.family_range.end"
          />
        </div>
      </section>
      <FamilyMemberRangeSection v-model="filterState.member_range" />
      <VolunteerSection v-model="filterState.volunteer" />
    </section>
    <div class="flex justify-end mt-3">
      <button class="btn btn-outline-secondary mr-2" @click="resetState">
        ล้าง
      </button>
      <button class="btn btn-primary" @click="sendToStore">
        ค้นหา
      </button>
    </div>
  </FilterLayout>
</template>

<script setup>
import AddressSection from "./component/AddressSection.vue";
import HouseholdCharacteristicsSection from "./component/HouseholdCharacteristicsSection.vue";
import ProblemSection from "./component/ProblemSection.vue";
import HouseStableSection from "./component/HouseStableSection.vue";
import AccommodationSection from "./component/AccommodationSection.vue";
import FamilyMemberRangeSection from "./component/FamilyMemberRangeSection.vue";
import VolunteerSection from "./component/VolunteerSection.vue";
import FilterLayout from "./layout/index.vue";
import { reactive, onMounted, ref } from "vue";
import { useStore } from "vuex";
import { getAllowActionByCurrRole } from "@/utils/get-roles"
// START: declare data
const INIT_FILTER_VALUE = {
  address: {
    amphur: null,
    province: null,
    tumbol: null,
    village: null,
  },
  family_range: {
    start: null,
    end: null,
  },
  house_type: [],
  house_solidity: null,
  household_type: [],
  member_range: {
    start: null,
    end: null,
  },
  problems: [],
  volunteer: null,
  filter_orders: [],
  cm_uid: null
};
const store = useStore();
const filterState = reactive(JSON.parse(JSON.stringify(INIT_FILTER_VALUE)));
const advance_filter = ref(false);

onMounted(() => {
  const test = store.getters["householdFilter/getFilterForApi"];
  Object.assign(
    filterState,
    JSON.parse(JSON.stringify(store.getters["householdFilter/getAllFilter"]))
  );
  if(localStorage.getItem("volunteerData")){
    filterState.volunteer = JSON.parse(localStorage.getItem("volunteerData"))
  }
  advance_filter.value = filterState.advance_filter
});

const resetState = () => {
  const initFilter = JSON.parse(JSON.stringify(INIT_FILTER_VALUE))
  initFilter.address.province = filterState.address.province
  Object.assign(filterState, initFilter);
};
const sendToStore = () => {
  let result = filterState;
  result.advance_filter = advance_filter.value;
  if(localStorage.getItem("volunteerData")){
    result.volunteer = JSON.parse(localStorage.getItem("volunteerData"))
  }
  store.dispatch(
    "householdFilter/setStore",
    JSON.parse(JSON.stringify(result))
  );
};

const updateAddress = (evt, key) => {
  filterState.address[key] = evt;
};
</script>
